export const formatAmount = (amount: number | undefined): string => {
  if (typeof amount !== 'number') {
    amount = 0; 
  }

  return new Intl.NumberFormat('us-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};